/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Use_Leave_To_Remove_YourselfInputs */

const en_us2_group_use_leave_to_remove_yourself = /** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To leave, use “Leave group”.`)
};

const pt_br2_group_use_leave_to_remove_yourself = /** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sair, use “Sair da turma”.`)
};

const pt_pt2_group_use_leave_to_remove_yourself = /** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sair, use “Sair da turma”.`)
};

/** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */
const es_419_group_use_leave_to_remove_yourself = en_us2_group_use_leave_to_remove_yourself;

/** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */
const fr_fr2_group_use_leave_to_remove_yourself = en_us2_group_use_leave_to_remove_yourself;

/** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */
const de_de2_group_use_leave_to_remove_yourself = en_us2_group_use_leave_to_remove_yourself;

/** @type {(inputs: Group_Use_Leave_To_Remove_YourselfInputs) => LocalizedString} */
const it_it2_group_use_leave_to_remove_yourself = en_us2_group_use_leave_to_remove_yourself;

/**
* | output |
* | --- |
* | "To leave, use “Leave group”." |
*
* @param {Group_Use_Leave_To_Remove_YourselfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_use_leave_to_remove_yourself = /** @type {((inputs?: Group_Use_Leave_To_Remove_YourselfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Use_Leave_To_Remove_YourselfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_use_leave_to_remove_yourself(inputs)
	if (locale === "es-419") return es_419_group_use_leave_to_remove_yourself(inputs)
	if (locale === "pt-PT") return pt_pt2_group_use_leave_to_remove_yourself(inputs)
	if (locale === "fr-FR") return fr_fr2_group_use_leave_to_remove_yourself(inputs)
	if (locale === "de-DE") return de_de2_group_use_leave_to_remove_yourself(inputs)
	if (locale === "it-IT") return it_it2_group_use_leave_to_remove_yourself(inputs)
	return en_us2_group_use_leave_to_remove_yourself(inputs)
});
export { group_use_leave_to_remove_yourself as "group.use_leave_to_remove_yourself" }